import { render, staticRenderFns } from "./PreviewPersonalMatchingStatus.vue?vue&type=template&id=54ae733c"
import script from "./PreviewPersonalMatchingStatus.vue?vue&type=script&lang=js"
export * from "./PreviewPersonalMatchingStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports